/* Pearl Paradise PDP behaviour.

   DOUBLE-LOAD GUARD. This file is referenced by more than one section, so the
   browser may execute it twice on a page. Every block checks a flag before
   binding. Without it, two listeners fire on one element and a class toggle
   cancels itself out.

   Each concern is wrapped separately so a failure in one cannot disable the
   others. */

/* Explainer dialogs */
(function () {
  if (window.__ppdSheets) return;
  window.__ppdSheets = true;

  document.addEventListener('click', function (e) {
    var open = e.target.closest ? e.target.closest('[data-ppd-sheet]') : null;
    if (open) {
      var d = document.getElementById(open.getAttribute('data-ppd-sheet'));
      if (d) { if (d.showModal) { d.showModal(); } else { d.setAttribute('open', ''); } }
      return;
    }
    var close = e.target.closest ? e.target.closest('[data-ppd-close]') : null;
    if (close) {
      var dg = close.closest('dialog');
      if (dg) { if (dg.close) { dg.close(); } else { dg.removeAttribute('open'); } }
      return;
    }
    if (e.target && e.target.tagName === 'DIALOG' && e.target.classList.contains('ppd-sheet')) {
      if (e.target.close) e.target.close();
    }
  });
})();

/* Millimetre spacing, and the natural diamond note on the clasp row.

   THE SPACING PROBLEM, IN ONE PLACE FOR ALL THREE.
   House style is '10 mm'. The stored option value is closed up, '10mm',
   because the clasp tile image filename is derived from it by swapping spaces
   for dashes, and '10 mm' would resolve to clasp-...-10-mm-... which does not
   exist. Liquid puts the space back at render time in pp-option-group and
   pp-strand-specs, but the picker's own script writes the RAW value into two
   live elements whenever the selection changes, which clobbers both:

     [data-ppdh-chosen]  the 'Clasp style' readout above the tiles
     [data-ppd-optout]   the value on the Clasp row in the spec grid

   Only the tile labels survive on their own, because nothing rewrites them.
   So the space is put back here as well, on whatever changes.

   THE DIAMOND NOTE rides on the same observer because it depends on the same
   text. Liquid can only render the variant present at page load, which is the
   polished clasp, so without this the note could never appear on selection.

   DETECTING A DIAMOND CLASP: match the CARAT WEIGHT, not the word diamond.
   The first version tested for 'diamond' and worked until the Lattice clasp
   arrived, whose value reads '18K White Gold Lattice 0.13 cttw' and never
   says diamond at all. Every diamond clasp carries a cttw figure and nothing
   else in a clasp value does, so cttw is the reliable signal. Keep the word
   test as well, in case a future clasp names the stone but omits the weight.

   The size is deliberately NOT repeated in the sub-line. It already sits in
   the value above it. Liquid still renders it as a no-JS fallback and this
   overwrites it.

   WHY OBSERVERS RATHER THAN A CLICK HANDLER. The picker owns the swap and
   lives in another file. Watching the elements means this keeps working
   regardless of what does the swapping, and cannot race or double-bind.

   NO INFINITE LOOP. Each writer writes only when the normalized text differs
   from what is there. The write it triggers re-enters once, finds nothing to
   change, and stops.
*/
(function () {
  if (window.__ppdClaspSub) return;
  window.__ppdClaspSub = true;

  var DIAMOND = 'Natural diamonds, never lab-grown.';
  var IS_DIAMOND = /\bcttw\b|\bdiamond\b/i;

  function spaceMm(el) {
    var raw = el.textContent || '';
    var nice = raw.replace(/(\d)\s*mm/gi, '$1 mm');
    if (nice !== raw) el.textContent = nice;
    return nice;
  }

  function watch(el, fn) {
    fn();
    if (window.MutationObserver) {
      new MutationObserver(fn).observe(el, {
        childList: true, characterData: true, subtree: true
      });
    }
  }

  /* 1. the picker readout, one per option group */
  var chosen = document.querySelectorAll('[data-ppdh-chosen]');
  for (var i = 0; i < chosen.length; i++) {
    (function (el) { watch(el, function () { spaceMm(el); }); })(chosen[i]);
  }

  /* 2. the spec grid clasp row, plus its sub-line */
  var val = document.querySelector('[data-ppd-optout]');
  if (!val) return;
  var spec = val.closest ? val.closest('.ppd-spec') : null;
  if (!spec) return;

  /* Adopt the server-rendered sub-line if there is one, but only when it is
     ours. A setting note can sit in the same position and must not be
     overwritten. */
  var slot = null;
  var next = val.nextElementSibling;
  if (next && next.className.indexOf('ppd-spec__s') !== -1) {
    var t = next.textContent || '';
    if (/\d+\s*mm/i.test(t) || t.indexOf(DIAMOND) !== -1) slot = next;
  }

  function ensure() {
    if (slot && slot.parentNode) return slot;
    slot = document.createElement('div');
    slot.className = 'ppd-spec__s';
    slot.setAttribute('data-ppd-clasp-sub', '');
    val.insertAdjacentElement('afterend', slot);
    return slot;
  }

  watch(val, function () {
    var text = spaceMm(val).trim();
    if (IS_DIAMOND.test(text)) {
      ensure().textContent = DIAMOND;
    } else if (slot && slot.parentNode) {
      slot.textContent = '';
    }
  });
})();

/* Description read more */
(function () {
  var wraps = document.querySelectorAll('[data-ppd-desc]');
  for (var i = 0; i < wraps.length; i++) {
    (function (wrap) {
      if (wrap.getAttribute('data-ppd-ready') === '1') return;
      wrap.setAttribute('data-ppd-ready', '1');

      var btn = wrap.querySelector('[data-ppd-more]');
      var label = wrap.querySelector('[data-ppd-more-label]');
      if (!btn) return;

      var more = btn.getAttribute('data-more') || (label ? label.textContent : 'Read more');
      var less = btn.getAttribute('data-less') || 'Show less';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = !wrap.classList.contains('is-open');
        wrap.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', String(open));
        if (label) label.textContent = open ? less : more;
      });
    })(wraps[i]);
  }
})();

/* Request photos.
   One action. Name, email and a short note are required (Sept 30 2026). The
   note is shown open when the section's Require a note setting is on, and
   collapsed behind the old toggle when it is off. Its contents are folded
   into the contact body along with the product and SKU.

   The noun comes from the section so the wording follows the item: a
   necklace is a strand, earrings are a pair, a ring is a pearl. */
(function () {
  var root = document.querySelector('[data-ppd-req]');
  if (!root) return;
  if (root.getAttribute('data-ppd-ready') === '1') return;
  root.setAttribute('data-ppd-ready', '1');

  var who    = root.querySelector('[data-ppd-name]');
  var mail   = root.querySelector('[data-ppd-email]');
  var more   = root.querySelector('[data-ppd-more]');
  var extra  = root.querySelector('.ppd-extra');
  var ask    = root.querySelector('[data-ppd-ask]');
  var send   = root.querySelector('[data-ppd-send]');
  var note   = root.querySelector('[data-ppd-note]');
  var fields = root.querySelector('[data-ppd-fields]');
  var sent   = root.querySelector('[data-ppd-sent]');
  if (!mail || !send) return;

  var noun = root.getAttribute('data-ppd-noun') || 'pearls';
  var openLabel = more ? more.querySelector('[data-ppd-more-label]') : null;
  var openText  = openLabel ? openLabel.textContent : 'Ask for something specific';
  var closeText = 'Never mind';

  if (more && extra) {
    more.addEventListener('click', function () {
      var opening = extra.hidden;
      extra.hidden = !opening;
      more.setAttribute('aria-expanded', String(opening));
      if (openLabel) openLabel.textContent = opening ? closeText : openText;
      if (opening && ask) ask.focus();
    });
  }

  /* PHOTO REQUEST SYSTEM. Before the contact form goes to the inbox, the
     request is registered with the photo request endpoint, which creates the
     queue entry and the customer's private page and returns a PR number.

     The variant is read from the product form AT SUBMIT TIME, so a customer
     who switched to 18 inch yellow gold gets that strand photographed, not
     the one the page loaded with.

     If the endpoint is unset, slow or down, the contact form still submits
     exactly as before. The customer never sees a failure. */
  var ENDPOINT = window.ppPhotoEndpoint || 'https://photo-requests.jeremypshepherd.workers.dev/request';
  var shownAt = Date.now();

  var hp = document.createElement('input');
  hp.type = 'text';
  hp.name = 'website';
  hp.tabIndex = -1;
  hp.autocomplete = 'off';
  hp.setAttribute('aria-hidden', 'true');
  hp.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0';
  // Kept OUTSIDE the contact form so Shopify never receives an unknown field.
  // The Worker still gets its value from register() below.
  root.appendChild(hp);

  function currentVariantId() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i];
      if (f.closest && f.closest('[data-ppd-req]')) continue;
      var id = f.querySelector('[name="id"]');
      if (id && id.value) return id.value;
    }
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : '';
  }

  function register(noteText) {
    if (!ENDPOINT || !window.fetch) return Promise.resolve(null);
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 6000);
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: mail.value.trim(),
        name: who ? who.value.trim() : '',
        note: noteText,
        variant_id: currentVariantId(),
        url: window.location.origin + window.location.pathname,
        hp: hp.value,
        ms: Date.now() - shownAt
      }),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (res) { clearTimeout(timer); return res; });
  }

  var busy = false;
  send.addEventListener('click', function () {
    if (busy) return;
    // Required note (Sept 30 2026). The field carries data-ppd-ask-required
    // when the section setting is on. Each problem gets a visible message,
    // since a focus jump alone does not tell anyone what is wrong.
    var err = root.querySelector('[data-ppd-err]');
    var bad = null, msg = '';
    var needNote = ask && ask.hasAttribute('data-ppd-ask-required');
    if (who && !who.value.trim()) { bad = who; msg = 'Please add your name.'; }
    else if (!mail.value || mail.value.indexOf('@') === -1) { bad = mail; msg = 'Please check your email address.'; }
    else if (needNote && ask.value.trim().length < 10) {
      bad = ask;
      msg = 'Please add a short note for your specialist, even a single line.';
    }
    var fl = root.querySelectorAll('.ppd-field');
    for (var fi = 0; fi < fl.length; fi++) fl[fi].classList.remove('is-bad');
    if (bad) {
      var wrap = bad.closest ? bad.closest('.ppd-field') : null;
      if (wrap) wrap.classList.add('is-bad');
      if (err) { err.textContent = msg; err.hidden = false; }
      bad.focus();
      return;
    }
    if (err) err.hidden = true;
    busy = true;
    send.setAttribute('aria-busy', 'true');
    send.style.opacity = '.7';

    // Required mode has no collapsible wrapper, so the note always counts.
    var asked = ask && (!extra || !extra.hidden) ? ask.value.trim() : '';

    register(asked).then(function (res) {
      var sku = (res && res.sku) || root.getAttribute('data-ppd-sku') || 'this piece';
      var pr = res && res.request_number;
            if (pr) { try { if (window.gtag) window.gtag('event', 'photo_request', { request_number: pr, piece_count: 1 }); } catch (e) {} }
      var body = (pr ? 'Photo request ' + pr + ' for ' : 'Photo request for ') + sku;
      if (res && res.variant_title) body += ' (' + res.variant_title + ')';
      body += ' ' + window.location.origin + window.location.pathname;
      if (asked) body += '\n\nCustomer note: ' + asked;
      if (note) note.value = body;

      var skuInput = mail.form ? mail.form.querySelector('[name="contact[SKU]"]') : null;
      if (skuInput && res && res.sku) skuInput.value = res.sku;
      if (mail.form && pr) {
        var prInput = document.createElement('input');
        prInput.type = 'hidden';
        prInput.name = 'contact[Photo request]';
        prInput.value = pr;
        mail.form.appendChild(prInput);
      }

      // requestSubmit fires the submit event, which Shopify's contact-form bot
      // protection listens for to attach its token. submit() skips it.
      if (mail.form) {
        if (mail.form.requestSubmit) { mail.form.requestSubmit(); } else { mail.form.submit(); }
        return;
      }
      busy = false;
      send.removeAttribute('aria-busy');
      send.style.opacity = '';
      showSent();
    });
  });

  function showSent() {
    /* no form present, mockup fallback */
    if (fields) fields.style.display = 'none';
    if (sent) {
      sent.innerHTML = '<b>Thank you.</b> We will photograph the ' + noun +
        ' and send the images over, usually within one business day. It is held for you for ' +
        '48 hours from the moment we send them.';
      sent.classList.add('is-on');
    }
  }
})();

/* Arriving from a private photo page with ?pr=PR-1042. The customer wants a
   different length or clasp but the same photographed pearls, so every add
   to cart form on the page carries the request number, and the order-matching
   job links the order back to the request exactly as a buy from the photo
   page would. */
(function () {
  if (window.__ppdPhotoCarry) return;
  window.__ppdPhotoCarry = true;

  var m = window.location.search.match(/[?&]pr=(PR-[A-Za-z0-9-]{1,20})/);
  if (!m) return;
  var pr = m[1];

  function tag(form) {
    if (form.getAttribute('data-ppd-pr') === pr) return;
    if (form.closest && form.closest('[data-ppd-req]')) return;
    form.setAttribute('data-ppd-pr', pr);
    [['properties[_Photo request]', pr],
     ['properties[Photographed for you]', 'Photo request ' + pr]].forEach(function (p) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = p[0];
      i.value = p[1];
      form.appendChild(i);
    });
  }

  function run() {
    var forms = document.querySelectorAll('form[action*="/cart/add"]');
    for (var i = 0; i < forms.length; i++) tag(forms[i]);
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
})();
